import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  roles: [],
  permissions: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.roles = [];
      state.permissions = [];
    },
  },
});

export const { setUser, setRoles, setPermissions, logout } = authSlice.actions;
export default authSlice.reducer;
